import { Box, withStyles } from '@material-ui/core';

export const WrapperBox = withStyles(() => ({
  root: {},
}))(Box);

export const IconWrapperBox = withStyles(({ spacing }) => ({
  root: {
    maxWidth: 360,
    padding: spacing(0, 2),
    '& > svg': {
      width: '100%',
      height: 'auto',
    },
  },
}))(Box);
